import React, { useState } from 'react';
import convert from 'htmr';
import { assign } from 'lodash/fp';
import classnames from 'classnames';
import PlusIcon from '../../files/plus.svg';
import MinusIcon from '../../files/minus.svg';

const Accordion = ({ accordionMultiOpen = false, accordionItems = [] }) => {
  const accordionInitialState = {};
  const [activeState, setActiveState] = useState(accordionInitialState);

  const toggleAccordionSection = (id) => {
    setActiveState((state) =>
      assign(accordionMultiOpen ? state : accordionInitialState, {
        [id]: !state[id],
      })
    );
  };

  const accordionSection = ({ title, content, id }) => {
    const sectionClasses = classnames('accordion__section', {
      active: activeState[id],
    });

    return (
      <div key={id} className={sectionClasses}>
        <button
          className="accordion__tab"
          onClick={() => toggleAccordionSection(id)}
          aria-expanded={activeState[id] || false}
          aria-controls={id}
        >
          <div className="accordion__tab-title">{title}</div>
          <div className="accordion__tab-icon">
            {activeState[id] ? (
              <MinusIcon focusable={false} />
            ) : (
              <PlusIcon focusable={false} />
            )}
          </div>
        </button>
        <div id={id} className="accordion__content">
          {convert(content)}
        </div>
      </div>
    );
  };

  return (
    <div className="accordion">
      <div className="accordion__wrapper">
        {accordionItems.map(accordionSection)}
      </div>
    </div>
  );
};

export default Accordion;
